export default __webpack_public_path__ + "static/media/right.b60b46ca.svg";